import { ComponentProps, createContext } from "react"

import cssModule from "./index.module.css"
import { cx } from "classix"

export const FieldsetContext = createContext<{ disabled?: boolean }>({
	disabled: false
})

export type FieldsetProps = {
	borderless?: boolean
} & ComponentProps<"fieldset">

/**
 * Для группировки нескольких элементов управления.
 * Обертка вокруг [`<fieldset>`](https://developer.mozilla.org/ru/docs/Web/HTML/Reference/Elements/fieldset). *
 */
export function Fieldset({ children, className, disabled, borderless, ...props }: FieldsetProps) {

	return (
		<fieldset className={cx(cssModule.fieldset, borderless && cssModule.borderless, className)} disabled={disabled} {...props}>
			<FieldsetContext value={{ disabled }}>
				{children}
			</FieldsetContext>
		</fieldset>
	)
}
